import React from "react"
import { Container, Row, Col } from "reactstrap";
import styled from "styled-components";

import Layout from "../components/layout"
import SEO from "../components/seo"
import gens3d from "../images/3DGENS_LOGO.png"

import Banner from "../components/Banner";
import Section from "../components/Section";
import BackgroundSection from "../components/BackgroundSection";
import CardBorder from "../components/CardBorder";
import ButtonPlain from "../components/buttons/ButtonPlain";

import lisaP from "../images/lisa-printer.png";
import lisaPPro from "../images/lisapro-printer.png";
import centricP from "../images/photocentric.png";
import renAM from "../images/RenAM-500E.jpg";
import genceP from "../images/3dgence-printer.png";
import gencePD from "../images/3dgence-printer-double.png";
import gencePI from "../images/3dgence-printer-industry.png";
import gence420 from "../images/gence420.jpg";
import gence340 from "../images/gence340.jpg";
import gence421 from "../images/gence421.png";
import gence350 from "../images/gence350.png";
import genceMMS from "../images/genceMMS.png";
import ultimakerblur from "../images/printer.jpg";
import printerbanner from "../images/banner/page-banner/banner-printers.png";
import printerbannerv2 from "../images/banner3dgensprinter.png";
import printerbannermobile from "../images/banner/page-banner/mobile/banner-printers-mobile.png";
import combed from "../images/combed.png";
import { graphql } from "gatsby";
import CardSimple from "../components/CardSimple";

const PrinterInfoBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-evenly; 
  .flexbox{
    flex: 0 0 33%;
    margin: 0 10px;
  }
  .storydesc{
    font-weight: bold;
  }
  @media only screen and (max-width:800px) {
    flex-wrap: wrap;
    .flexbox{
      flex: 1 1 90%;
    }
  }
`
const PrinterBox = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  grid-template-rows: 50% 50%;
  gap: 10px;
  
  .imageBox{
    height: 20rem;

    img{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

`
const GridLayerBox = styled.div`
  display: grid;
  grid-template: 1fr / 1fr;

  * {
    grid-column: 1 / 1;
    grid-row: 1 / 1;
  }
  .itemPrinter{
    z-index: 2;
    padding: 1rem;
    border: 1px solid #1ae99e;
    background: #fff;
    
  }
  .itemSpec{
    z-index: 1;
    padding: 1rem;
    border: 1px solid #1ae99e;
    background: #ccc;
    h5{
      text-align: center;
    }
  }
  :hover{
    .itemPrinter{
      visibility: hidden;
    }
  }
`

const printerDetails = [
  {
    image : <img src={gence421}></img>,
    title : "3DGence Industry F421",
    description: "The Dual extruder 3D Printer designed for Industrial applications where accuracy, speed, comfort and safety are crucial while also suitable with a wide range of technical materials to accommodate your 3D printing needs.",
  },
  {
    image : <img src={gence350}></img>,
    title : "3DGence Industry F350",
    description: "The most versatile industrial 3D Printer capable of 3D printing with the widest range of engineering materials and producing high-quality and durable complex geometrical parts",
  },
  {
    image : <img src={lisaPPro}></img>,
    title : "Sinterit Lisa Pro",
    description: "Benchtop SLS 3D Printer for industrial quality and bigger prints!",
  },
  {
    image : <img src={renAM}></img>,
    title : "Renishaw RenAM 500E",
    description: "The Renishaw's RenAM 500E  is designed to offer value to new users, who want a safe starting point to develop their AM skills and understanding about 3D Metal Printing.",
  },
]

const printerSpecification = [
  {
    image : gence421,
    title : "3DGence Industry F421",
    description : "",
    specification : <p>
      Technology : FFF - Fused Filament Fabrication <br/><br/>
      Build Volume : 380 x 380 x 420 mm <br/><br/>
      Printhead : 2 with printhead purging system <br/><br/>
      Active Heating Chamber up to 195 °C <br/>
    </p>,
  },
  {
    image : gence340,
    title : "3DGence Industry F340",
    description : "",
    specification : <p>
    Technology : FFF - Fused Filament Fabrication <br/><br/>
    Build Volume : 260 x 300 x 340 mm <br/><br/>
    Printhead : 2 per module <br/><br/>
    Active Heating Chamber up to 85 °C <br/>
  </p>,
  },
  {
    image : gence350,
    title : "3DGence Industry F350",
    description : "",
    specification : <p>
    Technology : FFF - Fused Filament Fabrication <br/><br/>
    Build Volume : 340 x 340 x 350 mm <br/><br/>
    Printhead : 2 with printhead purging system <br/><br/>
    Active Heating Chamber up to 140 °C <br/>
  </p>,
  },
  {
    image : genceMMS,
    title : "3DGence Material Management System",
    description : "",
    specification : <p>
    Automatic Material Preparation <br/><br/>
    Multi Material Storage <br/><br/>
    High Temperature Part Annealing <br/>
  </p>,
  },
  {
    image : lisaPPro,
    title : "Sinterit Lisa Pro",
    description : "",
    specification : <p>
    Technology : SLS - Selective Laser Sintering <br/><br/>
    Build Volume : 110 x 160 x 245 mm <br/><br/>
    Laser System : IR Laser Diode 5 [W] ; λ =808 [nm] <br/><br/>
    Built-in Inert Gas Control System
  </p>,
  },
  {
    image : lisaP,
    title : "Sinterit Lisa",
    description : "",
    specification : <p>
    Technology : SLS - Selective Laser Sintering <br/><br/>
    Build Volume : 150 x 200 x 150 mm <br/><br/>
    Laser System : IR Laser Diode 5 [W] ; λ =808 [nm] <br/>
  </p>,
  },
]

const PrinterPage = ({ data }) => (
  <Layout>
    <SEO title="3DPrinter" />
    <Banner src={printerbannerv2} alt="banner" position="left">
      <h3>
        Bring Your Design to Reality <br/>with 3D Printing Technology
      </h3>
      <p>
        Showcase Your Project with Style
      </p>
    </Banner>
      <BackgroundSection>
        <Container>
          <h3 style={{color: "#000"}}>
            3D Printers
          </h3>
          <p>
            We are the authorised distributor for a wide range of 3D printers addressing the diverse technologies used in 3D printing from various reputable manufacturers. 
            The 3D printing technologies range from Fused Filament Fabrication, Daylight Polymer Printing and Selective Laser Sintering. 
            We are currently adding on to our stable of 3D printing solutions offering.
          </p>
        {/* </Container>
      </BackgroundSection>
      <BackgroundSection image={combed}>
        <Container> */}
          <PrinterInfoBox>
            { printerDetails.map((printer) => (
              <div className="flexbox">
                <CardSimple image={printer.image} title={printer.title} description={printer.description} />
              </div>
            )) }
          </PrinterInfoBox>
        </Container>
      </BackgroundSection>
      <BackgroundSection image={combed} color="#d8d8d8" id="printer">
        <Container>
          <h3 style={{color: "#000"}}>
            3D Printing Products
          </h3>
          {/* <Row>
            {data.allStrapiPrinters.edges.map(document => (
              <Col md="4">
                <div style={{display: "flex", height: "100%",}}>

                  <CardBorder image={document.node.image.publicURL} title={document.node.name}>
                    <div className="">
                        <ButtonPlain to={document.node.url}>
                          More Information
                        </ButtonPlain>
                    </div>
                  </CardBorder> 
                </div>
              </Col>
            ))}
          </Row> */}
          {/* <PrinterBox>
            {data.allStrapiPrinters.edges.map(document => (
                <GridLayerBox>
                  <div className="itemPrinter">
                    <h4>
                      {document.node.name}
                    </h4>
                    <div className="imageBox">
                      <img src={document.node.image.publicURL}/>
                    </div>
                  </div>
                  <div className="itemSpec">
                    <h5>
                      Specification
                    </h5>
                    <p>
                      Technology: SLS - Selective Laser Sintering <br/>
                      Technology: SLS - Selective Laser Sintering <br/>
                      Technology: SLS - Selective Laser Sintering <br/>
                      Technology: SLS - Selective Laser Sintering <br/>
                      Technology: SLS - Selective Laser Sintering <br/>
                      Technology: SLS - Selective Laser Sintering <br/>
                      Technology: SLS - Selective Laser Sintering <br/>
                    </p>
                  </div>
                </GridLayerBox>
            ))}
        </PrinterBox> */}
        <PrinterBox>
            {printerSpecification.map((printer) => (
                <GridLayerBox>
                  <div className="itemPrinter">
                    <h4>
                      {printer.title}
                    </h4>
                    <div className="imageBox">
                      <img src={printer.image}/>
                    </div>
                  </div>
                  <div className="itemSpec">
                    <h5>
                      {printer.title}<br/>
                      Specification
                    </h5>
                    {printer.specification}
                  </div>
                </GridLayerBox>
            ))}
        </PrinterBox>

        </Container>
      </BackgroundSection>
  </Layout>
)

export default PrinterPage

export const pageQuery = graphql`
                    query PrinterQuery  {
                      allStrapiPrinters{
                        edges {
                          node {
                            name
                            url
                            image{
                              publicURL
                            }
                          }
                        }
                      }
                    }
`